import { messages } from '@/socket'
export default {
  mounted () {
    messages.on('request', (data) => {
      this.$store.commit('support/SET_NEW_REQUEST', data)

      this.$store.dispatch('meta/setMeta', 'new-request')

      this.$store.dispatch('meta/setNotif', [ { key: 'help', value: true } ])
      // setTimeout(() => {
      // 	this.$store.dispatch('meta/setNotif', [ { key:'help', value:  false } ])
      // }, 3000)
    })
  }
}
